import type {MenuProps} from "antd"
import {Avatar, Button, Layout, Menu} from "antd"
import React, {useState} from "react"
import styles from "./Layout.module.less"
import {
    ContainerOutlined,
    LeftOutlined,
    PoweroffOutlined,
    RightOutlined,
    TeamOutlined,
    UserOutlined,
    SettingOutlined,
    GlobalOutlined
} from "@ant-design/icons"
import {AnimatePresence, motion} from "framer-motion"
import {Link, useLocation} from "react-router-dom"
import {useAuth0} from "@auth0/auth0-react"
import {useGetPermissionsQuery} from "../features/permission/permissionApi"

const {Content, Sider} = Layout

type MenuItem = Required<MenuProps>["items"][number]

function getItem(label: React.ReactNode, key: string, icon?: React.ReactNode, children?: MenuItem[]): MenuItem {
    return {
        key,
        icon,
        children,
        label: <Link to={key}>{label}</Link>
    } as MenuItem
}

interface LayoutContainerProps {
    children?: React.ReactNode
}

const LayoutContainer: React.FC<LayoutContainerProps> = ({children}) => {
    const location = useLocation()
    const {data} = useGetPermissionsQuery()
    const [collapsed, setCollapsed] = useState(true)
    const {user, logout} = useAuth0()

    const items: MenuItem[] = [
        getItem("Заявки", "/", <ContainerOutlined />),
        // TODO: Implement permissions correctly; the backend currently only supports 'can_use_system'.
        // getItem("Меню", "/menu", <ReadOutlined />),
        getItem("Клиенты", "/clients", <TeamOutlined />),
        getItem("Город", "/cities", <GlobalOutlined />),
        getItem("Филиалы", "/branches", <SettingOutlined />)
    ]

    return (
        <Layout className={styles.mainLayout}>
            <Sider
                theme="light"
                className={styles.sider}
                collapsed={collapsed}
                onCollapse={value => setCollapsed(value)}
            >
                <div className={styles.profile}>
                    <motion.div
                        className={styles.containerAvatar}
                        initial={{x: "100%", opacity: 0}}
                        animate={collapsed ? {x: "0px", opacity: 1} : {x: "0", opacity: 1}}
                    >
                        <Avatar style={{backgroundColor: "#ffba00"}} icon={<UserOutlined />} size="large" />
                    </motion.div>
                    <div className={styles.containerFullName}>
                        {/* @ts-ignore */}
                        <AnimatePresence>
                            {!collapsed && (
                                <motion.div
                                    key="full_name"
                                    initial={{left: "10%", opacity: 0}}
                                    animate={{left: "0", opacity: 1}}
                                    exit={{left: "10%", opacity: 0}}
                                    transition={{ease: "easeInOut", duration: 0.5}}
                                    className={styles.fullName}
                                >
                                    <p>{user?.name}</p>
                                </motion.div>
                            )}
                        </AnimatePresence>
                    </div>
                </div>
                <div className={styles.arrow} onClick={() => setCollapsed(val => !val)}>
                    <Button
                        className={styles.btn}
                        icon={collapsed ? <RightOutlined /> : <LeftOutlined />}
                        shape="circle"
                    />
                </div>
                <Menu
                    className={styles.menu}
                    theme="dark"
                    defaultSelectedKeys={[location.pathname]}
                    mode="inline"
                    items={items}
                />
            </Sider>
            <Content
                className={styles.layoutBackground}
                style={{
                    padding: "0 24px",
                    margin: 0,
                    minHeight: 280
                }}
            >
                <div className={styles.exit}>
                    <Button icon={<PoweroffOutlined />} onClick={() => logout({returnTo: window.location.origin})}>
                        Выйти
                    </Button>
                </div>
                {children}
            </Content>
        </Layout>
    )
}

export default LayoutContainer
